import { IUser } from "@multiweb/types/contracts";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

/**
 * Klient poskytující přístup k informacím o aktuálním přihlášeném uživateli
 * @includeToDoc
 */
export interface IUserClient {
    /**
     * Získá základní informace o aktuálně přihlášeném uživateli
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getCurrentUserInfo(cancellationToken?: CancellationToken): Promise<IUser>;
}
